module.exports = __webpack_public_path__ + "img/fb-icon.dd63dab3.png";